import * as React from "react";
import { SVGProps } from "react";
const SvgSkeleton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="skeleton_svg__e4AoEp3rf2s1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 740 210"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    {...props}
  >
    <style>
      {
        "@keyframes e4AoEp3rf2s3__sz{0%{width:89px;height:11px;animation-timing-function:cubic-bezier(.42,0,.58,1)}50%{width:220px;height:11px;animation-timing-function:cubic-bezier(.42,0,.58,1)}to{width:89px;height:11px}}@keyframes e4AoEp3rf2s6__sz{0%{width:200px;height:11px;animation-timing-function:cubic-bezier(.42,0,.58,1)}50%{width:100px;height:11px;animation-timing-function:cubic-bezier(.42,0,.58,1)}to{width:200px;height:11px}}@keyframes e4AoEp3rf2s9__sz{0%,to{width:130px;height:11px}50%{width:200px;height:11px}}"
      }
    </style>
    <rect
      width={89}
      height={11}
      rx={2}
      ry={2}
      fill="#f5f5f6"
      strokeWidth={0}
      style={{
        animation: "e4AoEp3rf2s3__sz 3000ms linear infinite normal forwards",
      }}
    />
    <rect
      width={740}
      height={36}
      rx={2}
      ry={2}
      transform="translate(0 18)"
      fill="#f5f5f6"
      strokeWidth={0}
    />
    <g transform="translate(0 78)">
      <rect
        width={200}
        height={11}
        rx={2}
        ry={2}
        fill="#f8f8f8"
        strokeWidth={0}
        style={{
          animation: "e4AoEp3rf2s6__sz 3000ms linear infinite normal forwards",
        }}
      />
      <rect
        width={740}
        height={36}
        rx={2}
        ry={2}
        transform="translate(0 18)"
        fill="#f8f8f8"
        strokeWidth={0}
      />
    </g>
    <g transform="translate(0 156)">
      <rect
        width={130}
        height={11}
        rx={2}
        ry={2}
        fill="#fafafb"
        strokeWidth={0}
        style={{
          animation: "e4AoEp3rf2s9__sz 3000ms linear infinite normal forwards",
        }}
      />
      <rect
        width={740}
        height={36}
        rx={2}
        ry={2}
        transform="translate(0 18)"
        fill="#fafafb"
        strokeWidth={0}
      />
    </g>
  </svg>
);
export default SvgSkeleton;
